import React, { useEffect, useState } from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ReliabilityCareer from '../molecules/CareerComponents/ReliabilityCareer/ReliabilityCareer'
import CommitmentCareer from '../molecules/CareerComponents/CommitmentCareer/CommitmentCareer'
import Footer from '../organisms/Footer/Footer'
import CallbackForm from '../molecules/CareerComponents/CallbackFrom/CallbackForm'
import { getPageData, useData } from '../../app/helper/functions'
import { motion } from 'framer-motion'
import { Job } from '../../app/utlis/type'
import { getJobPosts } from '../../app/helper/jobService'

const CareerPage = () => {
    const { data } = useData();
    const careerData = getPageData(data, 'careerPage');
    const [jobs, setJobs] = useState<Job[]>([]);
    const [loading, setLoading] = useState(false)

    // Animation variants
    const fadeIn = {
        hidden: { opacity: 1 },
        visible: { opacity: 1, transition: { duration: 0.8 } }
    }

    const slideUp = {
        hidden: { y: 50, opacity: 0 },
        visible: { y: 0, opacity: 1, transition: { duration: 0.6 } }
    }

    const staggerChildren = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.2
            }
        }
    }
    useEffect(() => {
        try {
            setLoading(true);
            getJobPosts().then((res: any) => {
                setJobs(res)
            })
        } catch (err) {
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    }, []);
    
    return (
        <div>
            <motion.div
                className='bg-blackDark bg-center bg-cover bg-no-repeat'
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.2 }}
                variants={fadeIn}
            >
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col pb-8 gap-4 md:gap-6 justify-center items-center pt-24 md:pt-36 lg:pt-52'>
                        <motion.img
                            src={images.CAREERBANNER}
                            className='w-[90%] sm:w-[85%] md:w-[80%]'
                            variants={slideUp}
                        />
                        <motion.div
                            className='text-white flex flex-col gap-1 md:gap-2 relative text-center justify-center items-center px-4 sm:px-[8%] md:px-[10%]'
                            variants={staggerChildren}
                        >
                            <motion.div
                                className='font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-1 md:mb-2'
                                variants={slideUp}
                            >
                                {careerData.title}
                            </motion.div>
                            <motion.div
                                className='font-normal text-lg sm:text-xl md:text-2xl'
                                variants={slideUp}
                            >
                                {careerData.description}
                            </motion.div>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
            <motion.div
                className='bg-darkGreyPrimary'
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.2 }}
                variants={fadeIn}
            >
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ amount: 0.2 }}
                    variants={slideUp}
                >
                    <Heading className='bg-darkGreyPrimary pt-8 md:pt-12'
                        subTitle='Job Positions'
                        text="We are always looking for creative, talented self-starters to join the Sattva Tech family.
                              Check out our open positions and fill out an application." />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ amount: 0.1 }}
                    variants={slideUp}
                    className="px-4 md:px-0"
                >
                    <ReliabilityCareer jobs={jobs}/>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ amount: 0.1 }}
                    variants={slideUp}
                    className="px-4 md:px-0"
                >
                    <CommitmentCareer careerData={careerData} />
                </motion.div>

                {/* <Heading className='bg-darkGreyPrimary'
                    subTitle='Gallery of the our memories'
                    title='Gallery' />
                <GalleryComponent /> */}

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ amount: 0.1 }}
                    variants={slideUp}
                >
                    <Heading className='bg-darkGreyPrimary'
                        subTitle='Get In Touch With Us' />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ amount: 0.1 }}
                    variants={slideUp}
                    className="px-4 md:px-0"
                >
                    <CallbackForm />
                </motion.div>

                <Footer />
            </motion.div>
        </div>
    )
}

export default CareerPage
